<template>
    <fragment>
        <InsideHeader title="Dashboard" :bredcrumb="breadcrumb" />
        <section class="about-us-area">
            <div class="container">
                <div class="row align-items-center">
                    
                    <div class="col-12 col-sm-12 col-md-4">
                        <div class="single-features wow fadeInLeft shadow" data-wow-duration="1.0s" data-wow-delay=".4s">
                            <div class="hover-content"></div>
                            <div class="icon-wave-bg" >
                                <i class="fas fa-qrcode"></i>
                            </div>
                            <div class="single-feature-content">
                                <h4>(100)</h4>
                                <h2>Total Requests</h2>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-sm-12 col-md-4">
                        <div class="single-features wow fadeInLeft shadow" data-wow-duration="1.0s" data-wow-delay=".4s">
                            <div class="hover-content"></div>
                            <div class="icon-wave-bg" >
                                <i class="fas fa-file-upload"></i>
                            </div>
                            <div class="single-feature-content">
                                <h4>&nbsp;</h4>
                                <h2>Upload Menu</h2>
                            </div>
                        </div>
                    </div>     

                </div>
            </div>
        </section>
    </fragment>
</template>

<script>
import InsideHeader from "../components/InsideHeader.vue";
export default {
    components: {
        InsideHeader
    },
    data(){
        return {
            breadcrumb: [
                {title: 'Home', path:'/'},
                {title: this.$route.name, path:'#'}
            ]
        }
    },
}
</script>